import { CRM_CONTAINER_LAYOUT_TYPES } from 'crm-cards-sdk/types/CrmContainerLayout';
import CardListContainerFormatter from './CardListContainerFormatter';
import CardStackContainerFormatter from './CardStackContainerFormatter';
import ColumnsContainerFormatter from './ColumnsContainerFormatter';
import GridContainerFormatter from './GridContainerFormatter';
import SingleCardContainerFormatter from './SingleCardContainerFormatter';
import TabbedContainerFormatter from './TabbedContainerFormatter';
import UIGridContainerFormatter from './UIGridContainerFormatter';
import MasonryContainerFormatter from './MasonryContainerFormatter';
import CustomContainerFormatter from './CustomContainerFormatter';
import Raven from 'raven-js';

/**
 * Default registry of container formatters mapped by layout type.
 * This can be extended with custom formatters.
 */
export const DEFAULT_CONTAINER_FORMATTERS = {
  [CRM_CONTAINER_LAYOUT_TYPES.LIST]: CardListContainerFormatter,
  [CRM_CONTAINER_LAYOUT_TYPES.STACK]: CardStackContainerFormatter,
  [CRM_CONTAINER_LAYOUT_TYPES.COLUMNS]: ColumnsContainerFormatter,
  [CRM_CONTAINER_LAYOUT_TYPES.GRID]: GridContainerFormatter,
  [CRM_CONTAINER_LAYOUT_TYPES.SINGLE_CARD]: SingleCardContainerFormatter,
  [CRM_CONTAINER_LAYOUT_TYPES.TABS]: TabbedContainerFormatter,
  [CRM_CONTAINER_LAYOUT_TYPES.UIGRID]: UIGridContainerFormatter,
  [CRM_CONTAINER_LAYOUT_TYPES.MASONRY]: MasonryContainerFormatter,
  [CRM_CONTAINER_LAYOUT_TYPES.CUSTOM]: CustomContainerFormatter
};

/**
 * Gets a container formatter for the specified layout type from the registry.
 * If no formatter is found for the layout type, falls back to the list formatter.
 *
 * This overload supports both standard and extended (custom) formatter registries.
 */
export function getContainerFormatter(layout, registry = DEFAULT_CONTAINER_FORMATTERS) {
  const layoutType = layout.type === CRM_CONTAINER_LAYOUT_TYPES.CUSTOM ? layout.name : layout.type;

  // Cast to any to support both standard and custom layout types
  const formatter = registry[layoutType];
  if (!formatter) {
    Raven.captureException(new Error(`ContainerFormatterRegistry: requested formatter not found. Layout type: ${layoutType}`));
    // Fall back to LIST formatter if no formatter is found for the layout type
    return CardListContainerFormatter;
  }
  return formatter;
}

/**
 * Merges custom formatters with the default registry.
 * This is the preferred way to extend the registry with custom formatters.
 *
 * This version supports both standard and extended (custom) formatter registries.
 */
export function mergeWithDefaultFormatters(customLayouts) {
  return Object.assign({}, DEFAULT_CONTAINER_FORMATTERS, customLayouts);
}